import { useMemo } from 'react';
import {
  AlignCenterIcon,
  AlignLeftIcon,
  AlignRightIcon,
  JustifyIcon,
} from '../../icons';
import styles from '../styles.module.scss';

const alignments = ['left', 'center', 'right', 'justify'];

const ICONS = {
  left: <AlignLeftIcon />,
  center: <AlignCenterIcon />,
  right: <AlignRightIcon />,
  justify: <JustifyIcon />,
};

export default function AlignmentPicker({ onClick }) {
  const handleOnClick = (event) => {
    if (!onClick) return;

    const alignment = event.target.dataset.value;
    if (alignment) {
      onClick(alignment);
    }
  };

  const renderAlignmentButton = (alignment, onClickHandler) => (
    <button
      key={alignment}
      className={styles['dropdown-item']}
      type="button"
      onClick={onClickHandler}
      data-event="backAlignment"
      data-value={alignment}
    >
      <span style={{ pointerEvents: 'none' }}>{ICONS[alignment]}</span>
    </button>
  );

  const renderAlignments = useMemo(() => {
    const dropdown = [];
    for (let i = 0; i < alignments.length; i++) {
      const alignment = alignments[i];
      dropdown.push(renderAlignmentButton(alignment, handleOnClick));
    }

    return dropdown;
  }, [alignments]);

  return <div className={styles.dropdown}>{renderAlignments}</div>;
}
